import { render, staticRenderFns } from "./TitleListEntry.vue?vue&type=template&id=2fbbe23a&scoped=true&"
import script from "./TitleListEntry.vue?vue&type=script&lang=ts&"
export * from "./TitleListEntry.vue?vue&type=script&lang=ts&"
import style0 from "./TitleListEntry.vue?vue&type=style&index=0&id=2fbbe23a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbbe23a",
  null
  
)

export default component.exports